import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";
import { Typography } from "@/components/ui/typography";

export type UtPolar = {
  do_you_have_ut_reading_info: PolarYesNoUndefined;
  calculate_at_worst_case: PolarYesNoUndefined;
  is_ut_reading_less_than_04: PolarYesNoUndefined;
  per_code_line_leaking_do_you_know_diameter: PolarYesNoUndefined;
};
type UtChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof UtPolar }) => void;
  polarQuestions: UtPolar;
};
export function UtChecks({ onHandleYesNo, polarQuestions }: UtChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Do you have UT reading information to provide?"
        onNoClick={() => onHandleYesNo({ value: "no", key: "do_you_have_ut_reading_info" })}
        onYesClick={() => onHandleYesNo({ value: "yes", key: "do_you_have_ut_reading_info" })}
        selection={polarQuestions.do_you_have_ut_reading_info}
      />
      <PolarQuestion
        shouldRender={polarQuestions.do_you_have_ut_reading_info === "no"}
        question="Do you wish to calculate at worst case i.e remaining wall equals 0 in?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "calculate_at_worst_case" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "calculate_at_worst_case" });
        }}
        selection={polarQuestions.calculate_at_worst_case}
      />
      <PolarQuestion
        shouldRender={polarQuestions.do_you_have_ut_reading_info === "yes"}
        question="Is the lowest UT reading less than 0.04in?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "is_ut_reading_less_than_04" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "is_ut_reading_less_than_04" });
        }}
        selection={polarQuestions.is_ut_reading_less_than_04}
      />
      <PolarQuestion
        shouldRender={polarQuestions.is_ut_reading_less_than_04 === "yes"}
        question="Per code, the line is considered leaking at UTs below 0.04in. Do you know the diameter projection that encompasses the entire thin pipe anomaly?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "per_code_line_leaking_do_you_know_diameter" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "per_code_line_leaking_do_you_know_diameter" });
        }}
        selection={polarQuestions.per_code_line_leaking_do_you_know_diameter}
      />
      {polarQuestions.per_code_line_leaking_do_you_know_diameter === "no" && (
        <Typography variant="text-md" weight="semibold" className="text-primary-500">
          The calculations will be run worst case assuming the entire line is at below 0.04in remaining wall. This will
          result in the highest layer count. We recommend finding the diameter projection that encompasses the entire
          thin pipe anomaly if possible
        </Typography>
      )}
    </>
  );
}
